import { Link } from 'react-router-dom';
import { styled, Theme } from '@mui/material';
import { coreThemeColors } from '@youscience/theme';
import { CoreBox } from '@youscience/core';

export const sxStyles = {
  title: {
    marginBottom: '0.5rem',
  },
  description: (theme: Theme) => ({
    color: theme.palette.grey['600'],
  }),
  buttonsWrap: {
    display: 'flex',
    maxHeight: '48px',
    marginTop: '1rem',
  },
  divider: (theme: Theme) => ({
    margin: '0 1rem',
    height: '3rem',
    borderRight: `1px solid ${theme.palette.divider}`,
  }),
};

export const StyledOpportunityCardWrap = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '12px',
  padding: '1.25rem',
  color: theme.palette.common.black,
  backgroundColor: theme.palette.common.white,
  boxShadow: `0px 8px 24px -4px ${theme.palette.divider}`,
  width: '100%',

  '&:hover': {
    boxShadow: `0px 8px 32px -4px ${theme.palette.divider}`,
  },

  [theme.breakpoints.up('sm')]: {
    maxWidth: '410px',
  },
}));

export const StyledOpportunitiesContent = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  marginTop: '1rem',
  height: '100%',
}));

export const StyledActionButton = styled(Link)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  fontSize: '0.938rem',
  color: coreThemeColors.secondary.main,

  '& > svg:first-of-type': {
    marginLeft: '0.625rem',
    fill: coreThemeColors.secondary.main,
  },
}));
